import variables from './variables'

export default {
  colors: {
    buttons: {
      primaryBackground: variables.colors.skittlesPink,
      secondaryText: variables.colors.skittlesPink,
      secondaryOutline: variables.colors.skittlesPink,
    },
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
}
